import { ChangeDetectionStrategy, Component, Input, signal, WritableSignal } from '@angular/core'
import { TuiIcon } from '@taiga-ui/core'
import { TranslatePipe } from '@ngx-translate/core'
import { TuiAccordion } from '@taiga-ui/experimental'
import { OrderBookViewType } from '@shared/components/trading/common/order-book/core/types/order-book-view.type'
import { OrderBookLinearComponent } from '@shared/components/trading/common/order-book/common/order-book-linear/order-book-linear.component'
import { OrderBookDiagrammaticComponent } from '@shared/components/trading/common/order-book/common/order-book-diagramic/order-book-diagrammatic.component'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { LiveTickerOrderBookInterface } from '@modules/stocks-module/live-ticker/interfaces/live-ticker-order-book.interface'

@UseLocales({ ru, en })
@Component({
	selector: 'app-order-book',
	templateUrl: './order-book.component.html',
	styleUrl: './order-book.component.scss',
	imports: [TranslatePipe, TuiIcon, TuiAccordion, OrderBookLinearComponent, OrderBookDiagrammaticComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderBookComponent {
	@Input() viewType: OrderBookViewType = 'linear'
	@Input() isExpanded: boolean = true
	@Input() isLoading: boolean = false
	@Input() orderBook: LiveTickerOrderBookInterface | null | undefined = null

	protected isOpen: WritableSignal<boolean> = signal(true)

	protected toggleOpen(): void {
		this.isOpen.update((value: boolean): boolean => !value)
	}
}
